import { createSlice } from '@reduxjs/toolkit'

type Layouttate = {
    // LayoutList: any,
    layout: []
}
/**
  * layout: Danh sách các layout widget
  * 
*/


const initialState: Layouttate = {
    layout: [],
}
export const LayoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {
        updateLayout: (state, action) => {
            state.layout = action.payload;
        }
    },
})

// Action creators are generated for each case reducer function
export const { updateLayout } = LayoutSlice.actions

export default LayoutSlice.reducer